export default {
  'OnTheMenu':'MENU_TAB_MENU',
  'Stats':'MENU_TAB_STATS',
};


// WEBPACK FOOTER //
// ./modules/menu/constants/TabConstants.js